document.addEventListener("DOMContentLoaded", async () => {
  console.log("checking if we have a free advent item in the cart");
  const fetchCart = async () => {
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data;
  };

  const cart = await fetchCart();

  // remove the free advent item from the cart if it is there
  // we can check it by looking for the property Gift: "Free Advent Item"
  const freeAdventItem = cart.items.find(
    (item) => item.properties && item.properties.Gift === "Free Advent Item"
  );
  if (freeAdventItem) {
    console.log("removing free advent item from cart", freeAdventItem);
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: parseInt(freeAdventItem.id).toString(),
        quantity: 0,
      }),
    });
  }
});
